import { render } from "./OrderFilters.vue?vue&type=template&id=881e6d3c"
import script from "./OrderFilters.vue?vue&type=script&lang=js"
export * from "./OrderFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__